import {FormattedMessage, useIntl} from "react-intl";
import React, {useEffect, useState} from "react";
import {RequestVisitorDto} from "../../../modules/vms/dto/RequestVisitorDto";
import {RequestVisitorSearchCondition} from "../../../modules/vms/dto/RequestVisitorSearchCondition";
import {RequestVisitorApi} from "../../../modules/vms/api/RequestVisitorApi";
import {HttpStatus} from "../../../modules/common/enums/HttpStatus";
import dayjs from "dayjs";
import {Formats} from "../../../constants/Formats";
import {Chip, Divider, Stack} from "@mui/material";

export type VisitorPromptProps = {
    onSelect: (item: RequestVisitorDto) => void;
};

const VisitorQuickSelect: React.FC<VisitorPromptProps> = (props) => {

    // 查询结果
    const [visitors, setVisitors] = useState(new Array<RequestVisitorDto>());

    useEffect(() => {
        // 查询最近100天的访客
        const searchCondition = new RequestVisitorSearchCondition();
        searchCondition.paginationFlag = false;
        searchCondition.arriveDateFrom = dayjs().add(-100, "days").format(Formats.DATE_SIMPLE);
        handleSearch(searchCondition);
    }, []);

    const handleSearch = async (searchCondition: RequestVisitorSearchCondition) => {
        const responseResult = await RequestVisitorApi.queryMyRequestVisitors(searchCondition);
        if (responseResult.status === HttpStatus.SUCCESS) {
            // 以姓名来过滤访客
            const visitorsMap = new Map<String, RequestVisitorDto>();
            const visitors = new Array<RequestVisitorDto>();
            for (let visitor of responseResult.data) {
                if (!visitorsMap.has(visitor.fullName)) {
                    visitorsMap.set(visitor.fullName, visitor);
                    const simpleVisitor = new RequestVisitorDto();
                    simpleVisitor.lastName = visitor.lastName;
                    simpleVisitor.firstName = visitor.firstName;
                    simpleVisitor.mobile = visitor.mobile;
                    simpleVisitor.email = visitor.email;
                    simpleVisitor.company = visitor.company;
                    simpleVisitor.driveType = visitor.driveType;
                    simpleVisitor.plateNumber = visitor.plateNumber;
                    simpleVisitor.plateNumberColor = visitor.plateNumberColor;
                    simpleVisitor.vehicleType = visitor.vehicleType;
                    simpleVisitor.vehicleRegistrationDate = visitor.vehicleRegistrationDate;
                    simpleVisitor.vehicleFuelType = visitor.vehicleFuelType;
                    simpleVisitor.vehicleEmissionStandard = visitor.vehicleEmissionStandard;
                    simpleVisitor.idNumber = visitor.idNumber;
                    visitors.push(simpleVisitor);
                }
            }

            setVisitors(visitors);
        }
    };

    const handleClick = (item: RequestVisitorDto) => {
        props.onSelect(item);
    }

    return (
        <Stack spacing={2}>
            <Divider textAlign="left"><FormattedMessage id="VMS_REQUEST_VISITOR_QUICK_SELECT"/></Divider>
            <Stack direction={'row'} spacing={2} useFlexGap flexWrap="wrap">
                {
                    visitors.map((item, index) => {
                        return <Chip key={index} label={item.lastName + ' ' + item.firstName} variant="outlined"
                                     onClick={() => handleClick(item)}/>
                    })
                }
            </Stack>
        </Stack>
    );
};

export default VisitorQuickSelect;